(function($) {

    $(function() {
        var body = $('body');

        if(body.hasClass('home')) {
            let mainCarousel = $('.process-carousel').owlCarousel({
                loop: true,
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 350,
                autoplayTimeout: 7000,
                autoplay: true,
                margin: 0,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                touchDrag: false,
                //mouseDrag: false,
            });

            /*==== research =====*/
            $('.research-carousel').owlCarousel({
                loop: true,
                items: 1,
                nav: true,
                dots: true,
                smartSpeed: 900,
                autoplayTimeout: 7000,
                autoplay: true,
                margin: 30,
                navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
                responsive : {
                    // breakpoint from 0 up
                    0 : {
                        items: 1
                    },
                    // breakpoint from 991 up
                    991: {
                        items: 1
                    },
                    // breakpoint from 992 up
                    992: {
                        items: 1
                    }
                }
            });

            /*==== news =====*/
            $('.news-carousel').owlCarousel({
                loop: false,
                rewind: true,
                items: 3,
                nav: true,
                dots: true,
                autoplayTimeout: 7000,
                autoplayHoverPause: true,
                smartSpeed: 500,
                center: false,
                autoplay: true,
                margin: 30,
                navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
                responsive : {
                    // breakpoint from 0 up
                    0 : {
                        items: 1
                    },
                    // breakpoint from 991 up
                    768: {
                        items: 2,
                        center: false
                    },
                    // breakpoint from 992 up
                    992: {
                        items: 3
                    }
                }
            });

        }

    });


})(jQuery);
